export default __webpack_public_path__ + "static/media/file-download.549416e0.svg";